import { gql } from '@apollo/client';

export const getSystemCurrencies = gql`
  query getSystemCurrencies {
    core {
      getSystemCurrencies {
        basicCurrencyIDNavigation {
          code
          id
          title
          symbol
        }
        secondaryCurrencyIDNavigation {
          code
          id
          title
          symbol
        }
      }
    }
  }
`;
